<div class="text-center">

  <mat-icon>sms</mat-icon>
  <h1 *ngIf="_message.id; else noMessageTitle" mat-dialog-title translate> dialog.message.update.title</h1>
  <ng-template #noMessageTitle>
    <h1 mat-dialog-title translate>dialog.message.create.title</h1>
  </ng-template>

  <div class="modal-body" mat-dialog-content>

    <div [ngClass] = "controlDate() ? 'card container border' : 'card container border-secondary'">

      <div class="row">
        <mat-form-field class="full-width m-3">
          <mat-label translate>dialog.message.generic.text</mat-label>
          <input [(ngModel)]="_message.text" matInput>
        </mat-form-field>
      </div>

      <div class="row">

        <div class="col-sm">

          <mat-form-field>

            <mat-label translate>dialog.message.generic.datebegin</mat-label>
            <input  matInput 
                    [(ngModel)]     = "_message.dateBegin" 
                    [min]           = "today"
                    [max]           = "_message.dateEnd" 
                    readonly        = "readonly"
                    [matDatepicker] = "datebegin">

            <mat-datepicker-toggle matSuffix [for]="datebegin">
              <mat-icon matDatepickerToggleIcon>arrow_drop_down</mat-icon>
            </mat-datepicker-toggle>

            <mat-datepicker #datebegin></mat-datepicker>

          </mat-form-field>

        </div>

        <div class="col-sm">

          <mat-form-field>

            <mat-label translate>dialog.message.generic.dateend</mat-label>

            <input  matInput 
                    [(ngModel)]     = "_message.dateEnd" 
                    [min]           = "_message.dateBegin"
                    readonly        = "readonly"
                    [matDatepicker] = "dateend">

            <mat-datepicker-toggle matSuffix [for]="dateend">
              <mat-icon matDatepickerToggleIcon>arrow_drop_down</mat-icon>
            </mat-datepicker-toggle>

            <mat-datepicker #dateend></mat-datepicker>

          </mat-form-field>

        </div>
      </div>
    </div>

    <br>

    <div [ngClass] = "!controlTarget() ? 'card container border' : 'card container border-secondary'">
      <div class="row">
        <div class="col-sm">
          <mat-form-field class="full-width mt-2">

            <mat-label translate>dialog.message.generic.visibility</mat-label>

            <mat-select matNativeControl [(ngModel)]="selectedVisibility">
              <mat-option *ngFor="let visibility of visibilities" [value]="visibility.level">
                <span translate>
                  {{visibility.title}}
                </span>
              </mat-option>
            </mat-select>

          </mat-form-field>
        </div>
      </div>

      <div *ngIf="selectedVisibility === 'service'" class="row mt-3">
        <div class="col-sm">

          <service-select   #serviceManager
                            [site]              = "site"
                            [autoSelectId]      = "_message?.msgServiceId"
                            [autoSelectFirst]   = "autoSelectFirst()"
                            class               = "mr-3"
                            (change)            = "setService($event)"></service-select>

        </div>
      </div>

      <div class="row">

        <div class="col-sm">
          <mat-label translate>dialog.message.generic.target</mat-label>  
        </div>
        
      </div>

      <div class="row mt-2">

        <div class="col-sm">
          <mat-checkbox [(ngModel)]="_message.tkTarg">
            <span translate>dialog.message.generic.tktarg</span>
          </mat-checkbox>
        </div>

        <div class="col-sm">
          <mat-checkbox [(ngModel)]="_message.dsTarg">
            <span translate>dialog.message.generic.dstarg</span>
          </mat-checkbox>
        </div>

        <div class="col-sm">
          <mat-checkbox [(ngModel)]="_message.apTarg">
            <span translate>dialog.message.generic.aptarg</span>
          </mat-checkbox>
        </div>

        <div class="col-sm">
          <mat-checkbox [(ngModel)]="_message.coTarg">
            <span translate>dialog.message.generic.cotarg</span>
          </mat-checkbox>
        </div>

      </div>

    </div>
  </div>


  <div class="modal-footer" mat-dialog-actions translate>

    <button type="button" class="btn btn-outline-danger" (click)="cancel()" translate>
      dialog.message.generic.cancel
    </button>

    <button *ngIf="_message.id; else noMessageConfirm" type="button" class="btn btn-outline-secondary" (click)="update()"
      translate>
      dialog.message.update.confirm
    </button>

    <ng-template #noMessageConfirm>
      <button type="button" class="btn btn-outline-secondary" (click)="create()" translate>
        dialog.message.create.confirm
      </button>
    </ng-template>

  </div>